export enum ReturnsSettingsTab {
  COVERAGE = "coverage",
  POLICIES = "policies",
  PORTAL = "portal",
  OPERATIONS = "operations",
  LABELS = "labels",
  LOCATIONS = "locations",
  SHOPPER_NOTIFICATIONS = "shopper-notifications",
  WAREHOUSE = "warehouse",
}

export const RETURNS_SETTINGS_TAB_QUERY_PARAM = "tab";

export function isReturnsSettingsTab(
  value: string | null,
): value is ReturnsSettingsTab {
  return Object.values<string>(ReturnsSettingsTab).includes(value ?? "");
}

/**
 * Where switching back lands from each tab. A tab replaces more than one old
 * page; this is the one a merchant would name if asked where the settings used
 * to live.
 */
export const LEGACY_SETTINGS_PATH_BY_TAB: Record<
  Exclude<ReturnsSettingsTab, ReturnsSettingsTab.SHOPPER_NOTIFICATIONS>,
  string
> = {
  [ReturnsSettingsTab.COVERAGE]: "coverage",
  [ReturnsSettingsTab.POLICIES]: "customer-portal",
  [ReturnsSettingsTab.PORTAL]: "customer-portal",
  [ReturnsSettingsTab.OPERATIONS]: "exchanges",
  [ReturnsSettingsTab.LABELS]: "shipping",
  [ReturnsSettingsTab.LOCATIONS]: "shipping",
  [ReturnsSettingsTab.WAREHOUSE]: "warehouse",
};

/** Shopper notifications replaced Marketing automations, not a settings page. */
export function legacySettingsPathForTab(
  tab: ReturnsSettingsTab,
): string | undefined {
  return tab === ReturnsSettingsTab.SHOPPER_NOTIFICATIONS
    ? undefined
    : LEGACY_SETTINGS_PATH_BY_TAB[tab];
}
